import React from "react"
import { CurrConvertPriceWithoutSymbol } from "../CurrencyConverter/CurrConvertPrice"

const CurrencyPriceNoSYmbol = ({ price }) => {
  return <>{CurrConvertPriceWithoutSymbol(price?.toLocaleString())}</>
}

export default CurrencyPriceNoSYmbol
